<template>
  <div class="my-tinting-form-area">
    <div class="c-round-box">
      <ul class="c-dot-list">
        <li>
          보유하고 있는 조색기를 등록하시면 신규 설치 업데이트 파일 정보를
          카카오톡 알림으로 받을 수 있습니다.
        </li>
      </ul>
    </div>
    <div class="c-swich-area">
      <!-- D: 일반조색기 -->
      <ul>
        <li
          class="c-swich-item"
          v-for="(item, idx) in data.list.list01"
          :key="idx"
        >
          <div class="text">
            <p class="date">
              <span>
                {{
                  item.regDt != null
                    ? item.useYn == "Y"
                      ? "등록일: "
                      : "등록 취소일: "
                    : "미등록"
                }}
                {{
                  item.regDt != null
                    ? item.useYn == "Y"
                      ? item.regDt
                      : item.mdfcnDt
                    : null
                }}
              </span>
            </p>
            <p class="name">{{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}</p>
          </div>

          <div class="c-swich">
            <input
              type="checkbox"
              :id="'tintinggroup1-' + idx"
              name="tintinggroup1"
              :checked="item.useYn == 'Y'"
              @click="btnCmd(item)"
            />
            <label :for="'tintinggroup1-' + idx">
              <span><span class="chk_no">미</span>등록</span>
            </label>
          </div>
        </li>
      </ul>
      <!-- // D: 일반조색기 -->
      <!-- D: 팬톤조색기 -->
      <ul>
        <li
          class="c-swich-item"
          v-for="(item, idx) in data.list.list02"
          :key="idx"
        >
          <div class="text">
            <p class="date">
              <span>
                {{
                  item.regDt != null
                    ? item.useYn == "Y"
                      ? "등록일: "
                      : "등록 취소일: "
                    : "미등록"
                }}
                {{
                  item.regDt != null
                    ? item.useYn == "Y"
                      ? item.regDt
                      : item.mdfcnDt
                    : null
                }}
              </span>
            </p>
            <p class="name">{{ item.prdctSeNm }}-{{ item.cmmPntSeNm }}</p>
          </div>

          <div class="c-swich">
            <input
              type="checkbox"
              :id="'tintinggroup2-' + idx"
              name="tintinggroup2"
              :checked="item.useYn == 'Y'"
              @click="btnCmd(item)"
            />
            <label :for="'tintinggroup2-' + idx">
              <span><span class="chk_no">미</span>등록</span>
            </label>
          </div>
        </li>
      </ul>
      <!-- // D: 팬톤조색기 -->
    </div>
  </div>
</template>
<script setup name="colorMng">
import { onMounted, reactive, inject, computed } from "vue";

import * as cmUtil from "@/utils/cmUtil.js";
import { api } from "@/plugins/api";

const url = inject("url_prefix");
const data = reactive({
  init: [
    {
      extCmmSn: 0,
      agencySn: "",
      prdctSeCd: "G",
      prdctSeNm: "일반",
      cmmPntSeCd: "WATER",
      cmmPntSeNm: "수성",
      cmmTypeCd: null,
      useYn: "N",
      regDt: null,
      mdfcnDt: null,
    },
    {
      extCmmSn: 0,
      agencySn: "",
      prdctSeCd: "G",
      prdctSeNm: "일반",
      cmmPntSeCd: "OIL",
      cmmPntSeNm: "유성",
      cmmTypeCd: null,
      useYn: "N",
      regDt: null,
      mdfcnDt: null,
    },
    {
      extCmmSn: 0,
      agencySn: "",
      prdctSeCd: "G",
      prdctSeNm: "일반",
      cmmPntSeCd: "COMPLEX",
      cmmPntSeNm: "수유성",
      cmmTypeCd: null,
      useYn: "N",
      regDt: null,
      mdfcnDt: null,
    },
    {
      extCmmSn: 0,
      agencySn: "",
      prdctSeCd: "P",
      prdctSeNm: "팬톤",
      cmmPntSeCd: "WATER",
      cmmPntSeNm: "수성",
      cmmTypeCd: null,
      useYn: "N",
      regDt: null,
      mdfcnDt: null,
    },
    {
      extCmmSn: 0,
      agencySn: "",
      prdctSeCd: "P",
      prdctSeNm: "팬톤",
      cmmPntSeCd: "OIL",
      cmmPntSeNm: "유성",
      cmmTypeCd: null,
      useYn: "N",
      regDt: null,
      mdfcnDt: null,
    },
    {
      extCmmSn: 0,
      agencySn: "",
      prdctSeCd: "P",
      prdctSeNm: "팬톤",
      cmmPntSeCd: "COMPLEX",
      cmmPntSeNm: "수유성",
      cmmTypeCd: null,
      useYn: "N",
      regDt: null,
      mdfcnDt: null,
    },
  ],
  list: {
    list01: [],
    list02: [],
  },
});

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  searchCmd();
});

/**********************
 * 조회 모음
 *********************/
async function searchCmd() {
  const res = await api.post(`${url}/colorCombin/selectMyUpdateList`, {
    agencySn: "",
  });

  // 01: 일반 / 02: 팬톤
  let list01 = [];
  let list02 = [];

  // MY조색기가 있는 경우
  if (res.data.length > 0) {
    for (let i in data.init) {
      for (let j in res.data) {
        if (
          data.init[i].prdctSeCd == res.data[j].prdctSeCd &&
          data.init[i].cmmPntSeCd == res.data[j].cmmPntSeCd
        ) {
          data.init[i].useYn = res.data[j].useYn;
          data.init[i].extCmmSn = res.data[j].extCmmSn;
          data.init[i].regDt = res.data[j].regDt;
          data.init[i].mdfcnDt = res.data[j].mdfcnDt;
        }
      }
    }
  }

  // 일반 / 팬톤 구분해서 리스트업
  for (let i in data.init) {
    if (data.init[i].prdctSeCd == "G") {
      list01.push(data.init[i]);
    } else {
      list02.push(data.init[i]);
    }
  }

  data.list.list01 = list01;
  data.list.list02 = list02;
}

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(chkItem) {
  const res = await api.post(`${url}/colorCombin/insertMyCombinMng`, {
    extCmmSn: chkItem.extCmmSn != "" ? chkItem.extCmmSn : 0,
    prdctSeCd: chkItem.prdctSeCd,
    cmmPntSeCd: chkItem.cmmPntSeCd,
    useYn: chkItem.useYn == "Y" ? "N" : "Y",
  });

  if (res.resultCode == 200) {
    if (chkItem.useYn == "Y") {
      await cmUtil.alert(
        chkItem.prdctSeNm +
          "-" +
          chkItem.cmmPntSeNm +
          " 조색기가 MY 조색기로 등록 취소되었습니다."
      );
    } else {
      await cmUtil.alert(
        chkItem.prdctSeNm +
          "-" +
          chkItem.cmmPntSeNm +
          " 조색기가 MY 조색기로 등록되었습니다."
      );
    }

    if (chkItem.prdctSeCd == "G") {
      await settingData(data.list.list01, chkItem);
    } else {
      await settingData(data.list.list02, chkItem);
    }
  }
}

/**********************
 * 선택 후 날짜 및 문구 수정
 *********************/
async function settingData(list, checkItem) {
  for (let i in list) {
    if (list[i].cmmPntSeCd == checkItem.cmmPntSeCd) {
      list[i].regDt = list[i].regDt == null ? todayDate.value : list[i].regDt;
      list[i].mdfcnDt = todayDate.value;
      list[i].useYn = checkItem.useYn == "Y" ? "N" : "Y";
    }
  }
}
</script>
